//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionFlagFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.05016 15L9.78016 13H16.6602L13.7502 21H15.8802L22.4302 3H11.3002L10.5702 5H5.30016L1.66016 15H9.05016Z" fill="currentColor" /></svg>;
}
export default IconActionFlagFill;